import type { AutoFormWidgetsProps } from '../autoForm'
import { InputWidget } from './inputWidget'

export function RangeWidget(props: AutoFormWidgetsProps) {
  return <InputWidget type="range" {...props} />
}
